<template>
  <router-view />
</template>

<script>

export default {
  name: 'InvoiceWrapper'
}
</script>
